<template>
  <div class="form-group">
    <w-radio-list v-if="contestType" class="form-group" :model="contestType" :values="contestTypes" />

    <w-radio-list
      v-if="schoolLevel && contestType.$model === 2"
      class="form-group"
      :model="schoolLevel"
      :values="schoolLevels"
    />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz danych szablonu dokumentu z procedury prezydenckiej
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      contestTypes: [
        { text: 'Artystyczny', value: 1 },
        { text: 'Wiedzowy', value: 2 }
      ],
      schoolLevels: [
        { text: 'Podstawowa', value: 1 },
        { text: 'Ponadpodstawowa', value: 2 }
      ]
    };
  },
  computed: {
    contestType() {
      return this.schema.document && this.schema.document.data && this.schema.document.data.contestType;
    },
    schoolLevel() {
      return (
        this.schema.document &&
        this.schema.document.data &&
        this.schema.document.data.school &&
        this.schema.document.data.school.level
      );
    }
  }
};
</script>
